/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { useEffect, useState } from 'react'

import { logger } from '@/utils/logger'

const log = logger.child({ file: 'src/hooks/useFullscreen.ts' })

export const useFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  // Request fullscreen on mount
  // useEffect(() => {
  //   const requestFullscreen = async () => {
  //     try {
  //       // Try different fullscreen methods for better browser compatibility
  //       if (document.documentElement.requestFullscreen) {
  //         await document.documentElement.requestFullscreen()
  //       } else if ((document.documentElement as any).webkitRequestFullscreen) {
  //         await (document.documentElement as any).webkitRequestFullscreen()
  //       } else if ((document.documentElement as any).mozRequestFullScreen) {
  //         await (document.documentElement as any).mozRequestFullScreen()
  //       } else if ((document.documentElement as any).msRequestFullscreen) {
  //         await (document.documentElement as any).msRequestFullscreen()
  //       }
  //       setIsFullscreen(true)
  //     } catch (error) {
  //       log.error({ error }, 'Fullscreen request failed')
  //     }
  //   }

  //   // Delay fullscreen request
  //   const timer = setTimeout(requestFullscreen, 500)
  //   return () => clearTimeout(timer)
  // }, [])

  // Handle fullscreen change events
  useEffect(() => {
    const abortController = new AbortController()
    const { signal } = abortController

    const handleFullscreenChange = () => {
      setIsFullscreen(
        !!(
          document.fullscreenElement ||
          (document as any).webkitFullscreenElement ||
          (document as any).mozFullScreenElement ||
          (document as any).msFullscreenElement
        ),
      )
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange, {
      signal,
    })
    document.addEventListener(
      'webkitfullscreenchange',
      handleFullscreenChange,
      { signal },
    )
    document.addEventListener('mozfullscreenchange', handleFullscreenChange, {
      signal,
    })
    document.addEventListener('MSFullscreenChange', handleFullscreenChange, {
      signal,
    })

    return () => {
      abortController.abort()
    }
  }, [])

  const requestFullscreen = async () => {
    try {
      if (document.documentElement.requestFullscreen) {
        await document.documentElement.requestFullscreen()
      } else if ((document.documentElement as any).webkitRequestFullscreen) {
        await (document.documentElement as any).webkitRequestFullscreen()
      } else if ((document.documentElement as any).mozRequestFullScreen) {
        await (document.documentElement as any).mozRequestFullScreen()
      } else if ((document.documentElement as any).msRequestFullscreen) {
        await (document.documentElement as any).msRequestFullscreen()
      }
    } catch (error) {
      log.error({ error }, 'Fullscreen request failed')
    }
  }

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if ((document as any).webkitExitFullscreen) {
      ;(document as any).webkitExitFullscreen()
    } else if ((document as any).mozCancelFullScreen) {
      ;(document as any).mozCancelFullScreen()
    } else if ((document as any).msExitFullscreen) {
      ;(document as any).msExitFullscreen()
    }
  }

  const toggleFullscreen = () => {
    if (isFullscreen) {
      exitFullscreen()
    } else {
      requestFullscreen()
    }
  }

  return {
    isFullscreen,
    requestFullscreen,
    exitFullscreen,
    toggleFullscreen,
  }
}
